































































import { listFactory } from '@/main/pages/listFactory';
import { openList } from '@/main/router/routerPath';
import { Cell, convertToObjects, Row } from '@/main/utils/table';
import { listMutations } from '@/modules/servis/zakazka/servisniPakety/store/types';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { NAME as ZAKAZKA_PRACOVNI_POZICE } from '@/modules/servis/zakazka/pracovniPozice/constants';
import { ERROR, TABLE_DATA } from '@/main/store/listEditTypes';
import { ListLoadBehavior } from '@/main/utils/listLoadBehavior';

import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';

import { ScreenSize } from '@/main/components/constants';

import Delete from '#components/dms/button/Delete.vue';

import { NAME, PAKET_STATUS, ND_STATUS, PP_STATUS } from './constants';
import { store } from './store/list';
import { PaketovyModul } from '../../paketovyModul';

export default listFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		Delete,
		DropButtons,
	},
	data() {
		return {
			visibleDeleteDialog: false as boolean | null,
			showArrow: false,
			lstServiceOrdersButtons: [
				{ labelKey: '' as string | null, click: '' as string | null, disable: '' as string | boolean | null, exist: true as boolean | null, icon: '' as string | null },
			],
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				nakladoveStredisko: `${this.storeUri}/${listMutations.SKLAD_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
				pracovnik: `${this.storeUri}/${listMutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
		naklStredFilter(): Record<string, any> {
			return { ProvozovnaId: this.provozovnaId };
		},
		enabled() : Record<string, boolean> {
			const enabled = {
				prepocetCeny: false,
				odepisPp: false,
				odepisNd: false,
				rozpadPkt: false,
			};
			if (this.selectedPacket) {
				const snStatus = parseInt(this.selectedPacket!.SnStatus, 10);
				const snPpStatus = parseInt(this.selectedPacket!.SnppStatus, 10);
				const snNdStatus = parseInt(this.selectedPacket!.SnndStatus, 10);

				const isRozpracovanyPaket = snStatus === PAKET_STATUS.ROZPRACOVANY_PAKET;
				const isPripravenKRealizaci = snStatus === PAKET_STATUS.PRIPRAVEN_K_REALIZACI;
				const isRealizaceUkoncena = snStatus === PAKET_STATUS.REALIZACE_UKONCENA;
				const isNdCastecneVJFND = snNdStatus === ND_STATUS.ND_CASTECNE_V_JFND;
				const isNdCekajiVJFND = snNdStatus === ND_STATUS.ND_CEKAJI_V_JFND;
				const isCastecneVydaneNn = snNdStatus === ND_STATUS.CASTECNE_VYDANE_ND;
				const isNdVydany = snNdStatus === ND_STATUS.ND_VYDANY;
				const isNdNejsouVJFND = snNdStatus === ND_STATUS.ND_NEJSOU_V_JFND;
				const isPaketBezNd = snNdStatus === ND_STATUS.PAKET_BEZ_ND;
				const isPpNeodepsany = snPpStatus === PP_STATUS.PP_NEODEPSANY;
				const isPaketBezPp = snPpStatus === PP_STATUS.PAKET_BEZ_PP;
				const isCastecneOdepsanePp = snPpStatus === PP_STATUS.CASTECNE_ODEPSANE_PP;
				const isPpOdepsany = snPpStatus === PP_STATUS.PP_ODEPSANY;

				if (snStatus === PAKET_STATUS.NUTNO_EDITOVAT_CJ_U_PP) {
					enabled.odepisPp = true;
				} else if ((isPaketBezNd || isNdVydany || isNdCekajiVJFND) && (isCastecneOdepsanePp || isPpNeodepsany)) {
					enabled.prepocetCeny = true;
					enabled.odepisPp = true;
				}

				if ((isNdNejsouVJFND || isNdCastecneVJFND) && snPpStatus! >= 0) {
					enabled.prepocetCeny = true;
					enabled.odepisNd = true;
				}

				if ((isPripravenKRealizaci && (isNdCastecneVJFND || isNdCekajiVJFND) && (isPpNeodepsany || isPaketBezPp))
					|| (isRozpracovanyPaket && (
						(isCastecneVydaneNn && (isCastecneOdepsanePp || isPpOdepsany || isPpNeodepsany || isPaketBezPp))
						|| (isNdVydany && (isCastecneOdepsanePp || isPpNeodepsany))
						|| ((isNdNejsouVJFND || isNdCastecneVJFND || isNdCekajiVJFND || isPaketBezNd) && (isCastecneOdepsanePp || isPpOdepsany))
					))
					|| (isRealizaceUkoncena && (isPaketBezNd || isNdVydany) && (isPpOdepsany || isPaketBezPp))) {
					enabled.rozpadPkt = true;
				}
			}
			return enabled;
		},
		serviceOrderButtons(): object {
			this.lstServiceOrdersButtons =		[
				{ labelKey: 'cmdRefresh', click: 'onRefreshClick', disable: false, exist: true, icon: '' },
				{ labelKey: 'SNRozpadPkt', click: 'onRozpadPktClick', disable: !this.enabled.rozpadPkt, exist: true, icon: '' },
				{ labelKey: 'SNOdepisPP', click: 'onOdepisPpClick', disable: !this.enabled.odepisPp, exist: true, icon: '' },
				{ labelKey: 'SNOdepisND', click: 'onOdepisNdClick', disable: !this.enabled.odepisNd, exist: true, icon: '' },
				{ labelKey: 'cmdAddCAPaket', click: 'onAddCaPaketClick', disable: false, exist: true, icon: '' },
				{ labelKey: 'cmdDel', click: 'visibleDeleteDialogForDD', disable: !this.selectedPacketId, exist: true, icon: 'el-icon-delete' },
				{ labelKey: 'SNPrepocet', click: 'onPrepocetCenyClick', disable: !this.enabled.prepocetCeny, exist: true, icon: '' },
			];
			return this.lstServiceOrdersButtons
				.filter((item) => ((item.labelKey !== undefined && item.labelKey != null) && item.exist))
				.map((item) => ({
					labelKey: item.labelKey,
					click: () => { this.call(item.click); },
					exist: item.exist,
					disable: item.disable,
					icon: item.icon,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
	},
	mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		visibleDeleteDialogForDD() {
			this.visibleDeleteDialog = true;
		},
		call(method:any) {
			(this as { [key:string]:any })[method]();
		},
		async loadData() {
			const schema = await this.schema();
			if(schema.message !== undefined)
			{
				return;	
			}
			this.updateFilter({ ZakazkaId: this.props.filter.ZakazkaId });
			await this.onRefreshClick();
		},
		async onRefreshClick() {
			this.startLoading();
			await this.tableData();
			if (this.table.rows.length) {
				this.selectedPacketId = this.selectedPacketId || this.table.rows[0].cells[0];
			} else {
				this.selectedPacketId = null;
			}
			await this.setPacketDetail(this.selectedPacketId);
			this.endLoading();
		},
		async rowSelected(cells: Cell[]) {
			this.setPacketDetail(cells[0]);
		},
		async setPacketDetail(selectedPacketId: number | null) {
			try {
				this.startLoading();
				this.selectedPacketId = selectedPacketId;
				if (this.selectedPacketId) {
					await this.fetchPacketDetail(this.selectedPacketId);
					this.selectedPacket = convertToObjects(this.table).find((row: Record<string, any>) => row.ZaznamId === this.selectedPacketId!)!;
				} else {
					this.selectedPacket = null;
					await this.filterInit();
				}
			} catch (err) {
				await this.$store.dispatch(ERROR, { err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		getExpandedRowContent(row: Row) {
			const rowObject = (convertToObjects({ rows: [row], columns: this.table.columns }))[0] as { TextHtml: string };
			return rowObject.TextHtml;
		},
		onProvozovnaIdChange() {
			this.strednaklOzn = null;
			this.strednaklOznText = null;
		},
		async onPrepocetCenyClick() {
			this.startLoading();
			await this.prepocetCeny();
			await this.onRefreshClick();
			this.endLoading();
		},
		onKdPaketyClick() {
			console.log('TODO: not implemented yet');
		},
		async onDeleteClick() {
			this.startLoading();
			this.visibleDeleteDialog = false;
			await this.deletePacket();
			this.refetchZakazkaPp();
			this.selectedPacketId = null;
			await this.onRefreshClick();
			this.refreshPreviousPage = true;
			this.endLoading();
		},
		onAddCaPaketClick() {
			this.refreshPreviousPage = true;
			openList(PaketovyModul.name, {
				filter: {
					ZakazkaId: this.props.filter.ZakazkaId,
					ProvozovnaId: this.provozovnaId,
					PracovnikId: this.pracovnikId,
					StrednaklOzn: this.strednaklOzn,
				},
				listLoadBehavior: ListLoadBehavior.AUTO_LOAD,
			});
		},
		async onOdepisNdClick() {
			this.startLoading();
			await this.odepisNd();
			await this.onRefreshClick();
			this.refreshPreviousPage = true;
			this.endLoading();
		},
		async onOdepisPpClick() {
			this.startLoading();
			await this.odepisPp();
			this.refetchZakazkaPp();
			await this.onRefreshClick();
			this.refreshPreviousPage = true;
			this.endLoading();
		},
		async onRozpadPktClick() {
			this.refreshPreviousPage = true;
			const questionResult = await this.showConfirm({
				message: this.LocalizeChyboveHlasky('RozpadPkt'),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
			if (questionResult) {
				this.startLoading();
				await this.rozpadPacketu();
				this.selectedPacketId = null;
				await this.onRefreshClick();
				this.endLoading();
			}
		},
		refetchZakazkaPp() {
			this.$store.dispatch(`${this.parentUri}/${ZAKAZKA_PRACOVNI_POZICE}_${TABLE_DATA}`, { filter: { ZakazkaId: this.props.filter.ZakazkaId } });
		},
		scrollNavbarRight() {
			const content = document.querySelector('.button-box-align');
			if (content !== null) {
				console.log('right call ');
				content.scrollLeft += 50;
			}
		},
		scrollNavbar(direction: string) {
			const content = document.querySelector('.button-box-align');
			if (content !== null) {
				if (direction === 'right') content.scrollLeft += 250;
				else content.scrollLeft -= 250;
			}
		},
		getWidth() {
			this.showArrow = window.innerWidth < 1315;
		},
	},
	created() {
		window.addEventListener('resize', this.getWidth);
	},
	destroyed() {
		window.removeEventListener('resize', this.getWidth);
	},

});
